export const mockMealOrders: any[] = [
    {
        id: 7,
        date: new Date(2021, 7, 1),
        student: 'Robin Doe',
        meal: 'Soupe',
        price: 100,
    },
    {
        id: 8,
        date: new Date(2021, 7, 2),
        student: 'Steve Doe',
        meal: 'Tartine',
        price: 100,
    },
    {
        id: 5,
        date: new Date(2021, 6, 1),
        student: 'Robin Doe',
        meal: 'Soupe',
        price: 100,
    },
    {
        id: 6,
        date: new Date(2021, 6, 2),
        student: 'Steve Doe',
        meal: 'Tartine',
        price: 100,
    },
    {
        id: 3,
        date: new Date(2021, 1, 1),
        student: 'Robin Doe',
        meal: 'Soupe',
        price: 100,
    },
    {
        id: 4,
        date: new Date(2021, 1, 2),
        student: 'Steve Doe',
        meal: 'Tartine',
        price: 100,
    },
    {
        id: 1,
        date: new Date(2021, 0, 1),
        student: 'John Doe',
        meal: 'Soupe',
        price: 100,
    },
    {
        id: 2,
        date: new Date(2021, 0, 2),
        student: 'Jane Doe',
        meal: 'Tartine',
        price: 100,
    },
];
